import React from 'react';
import { useTranslation } from 'react-i18next';
import LeftRight from "../../components/ui/LeftRight";
import {networkCard} from "../../constants/products/itNetworking";
import SlideUp from "../../components/ui/SlideUp";
import {itNetworkMonitoring} from "../../constants/meta";
import Meta from "../../components/common/Helmet";
import {downloadSvg} from "../../constants/data";

const ItNetworkingReportingAppliance = () => {
  const { t } = useTranslation();
  return (
    <div>
      <Meta
        title={itNetworkMonitoring.title}
        description={itNetworkMonitoring.description}
        canonical={itNetworkMonitoring.canonical}
        keywords={itNetworkMonitoring.keywords}
        ogTitle={itNetworkMonitoring.title}
        ogDescription={itNetworkMonitoring.description}
      />
      <div className="md:w-theme-container w-mobile-container mx-auto mt-12">
        <h2 className={`text-center md:w-[40%] mx-auto text-xl xl:text-xl md:text-2xl theme-font-bold uppercase mb-14`}>
          {t('itNetworkPage.title')}
        </h2>
        <div className="mt-20">
          <LeftRight
            sectionClass={`pb-10`}
            subtitle={t('itNetworkPage.productName')}
            titleClass={'text-gray-900'}
            isLeft={true}
            textPosition={'justify-center'}
            descriptionPosition={'text-center'}
            imgClass={'w-[85%] mx-auto'}
            descriptionList={[
              t('itNetworkPage.intro'),
              t('itNetworkPage.architecture')
            ]}
            icon={false}
            image={require(`../../assets/images/products/pages/it-network-reporting/2.png`)}
          />
        </div>
        <div className="add-square-bg">
          <h2 className={`flex justify-center items-center md:w-[40%] mx-auto text-xl xl:text-xl md:text-2xl theme-font-bold uppercase mb-14`}>
            {t('itNetworkPage.mainPointTitle')}
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-10 py-20">
            {networkCard.map((item, index) => (
              <SlideUp key={index+1} >
                <div className="card bg-slate-50 w-full text-center h-auto rounded-xl overflow-hidden border border-theme-color shadow-2xl">
                  <div className="w-36 h-36 flex justify-center items-center rounded-full border border-theme-color shadow-2xl mx-auto mt-10">
                    {item.imgName && (
                      <img
                        src={require(`../../assets/images/products/pages/it-network-reporting/icons/${item.imgName}`)}
                        alt={item.title}
                        className="w-16 h-16 object-cover"
                      />
                    )}
                  </div>
                  <div className="flex flex-col items-center text-section p-5 ">
                    <p className="text-lg">{t(`itNetworkPage.`+item.titleTranslateKey)}</p>
                    <p className="text-base text-gray-500 mt-5">{t(`itNetworkPage.`+item.descriptionTranslateKey)}</p>
                  </div>
                </div>
              </SlideUp>
            ))}
          </div>
        </div>
        <div className="w-full mb-20">
          <h2 className={`text-center md:w-[40%] mx-auto text-xl xl:text-xl md:text-2xl theme-font-bold uppercase mb-14`}>
            {t('itNetworkPage.tagline')}
          </h2>
          <div className="text-base">
            {t('itNetworkPage.features')}
          </div>
          <div className="text-base my-8">
            {t('itNetworkPage.interface')}
          </div>
          <div className="text-base">{t('itNetworkPage.support')}</div>
          <a
            target={'_blank'}
            href={require(`../../assets/uploads/pdf/it-networking.pdf`)}
            className="w-[120px] text-base mt-8 h-10 rounded-lg bg-theme-color text-white text-center flex items-center justify-center"
            dir="auto"
          >
            {downloadSvg}&nbsp;{t('common.download')}
          </a>
            <img className='mx-auto mt-12' src={require(`../../assets/images/products/pages/it-network-reporting/img.png`)} alt=""/>
        </div>
      </div>
    </div>
  );
};

export default ItNetworkingReportingAppliance;
